<script>
export default {
  props: {
    target: {
      /**
       * If not set, parent node is used
       */
      type: [HTMLElement, Function, String, undefined],
      required: false,
    },
  },
  methods: {
    getTarget() {
      if (typeof this.$props.target === 'function') {
        return this.$props.target()
      } else if (this.$props.target instanceof HTMLElement) {
        return this.$props.target
      } else if (typeof this.$props.target === 'string') {
        return document.getElementById(this.$props.target)
      } else {
        return this.$el.parentElement
      }
    },
  },
}
</script>
